import React from "react";
import { OnTheGoDiv } from "./styled";
import phones from "../../../assets/images/phones.png";

function OnTheGo() {
  return (
    <OnTheGoDiv>
      <div className="inner-container">
        <div className="roww">
          <div className="col-md-4 firstdiv">
            <h2>
              We are on the <span>go!</span>{" "}
            </h2>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quae vel
              in et, quod reiciendis nemo voluptate
            </p>
            <div className="buttondiv">
              <button className="firstbutton btn">Download </button>
              <button className="secondbutton btn">Download</button>
            </div>
          </div>
          <div className="col-md-6 seconddiv">
            <img src={phones} />
          </div>
        </div>
      </div>
    </OnTheGoDiv>
  );
}

export default OnTheGo;
